import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    padding: tokens.spacingHorizontalL,
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
  },
  headerTitle: {
    fontWeight: tokens.fontWeightSemibold as unknown as number,
    color: tokens.colorNeutralForeground1,
  },
  copyBtn: {
    minWidth: 'auto',
    padding: '2px',
  },
  conversationBox: {
    padding: tokens.spacingHorizontalM,
    backgroundColor: tokens.colorNeutralBackground3,
    borderRadius: tokens.borderRadiusSmall,
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground1,
    maxHeight: '500px',
    overflow: 'auto',
    wordBreak: 'break-word' as const,
    lineHeight: '1.5',
    '& .conv-date-header': {
      marginTop: '8px',
      marginBottom: '4px',
      paddingTop: '4px',
      paddingBottom: '4px',
      borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
      fontSize: tokens.fontSizeBase200,
      color: tokens.colorNeutralForeground3,
      fontWeight: tokens.fontWeightSemibold as unknown as number,
    },
    '& .conv-msg-card-pa': {
      marginTop: '4px',
      marginBottom: '4px',
      padding: '8px',
      borderLeft: `3px solid ${tokens.colorBrandForeground1}`,
      backgroundColor: tokens.colorNeutralBackground1,
      borderRadius: tokens.borderRadiusSmall,
    },
    '& .conv-msg-card-ma': {
      marginTop: '4px',
      marginBottom: '4px',
      padding: '8px',
      borderLeft: `3px solid ${tokens.colorPaletteBerryForeground1}`,
      backgroundColor: tokens.colorNeutralBackground1,
      borderRadius: tokens.borderRadiusSmall,
    },
    '& .conv-msg-header': {
      marginBottom: '4px',
    },
    '& .conv-msg-sender': {
      fontWeight: tokens.fontWeightSemibold as unknown as number,
      color: tokens.colorNeutralForeground1,
    },
    '& .conv-msg-time': {
      color: tokens.colorNeutralForeground3,
      fontSize: tokens.fontSizeBase200,
      marginLeft: '8px',
    },
    '& .conv-msg-body': {
      color: tokens.colorNeutralForeground1,
    },
    '& blockquote': {
      margin: '4px 0',
      padding: '2px 8px',
      backgroundColor: tokens.colorNeutralBackground4,
      borderRadius: tokens.borderRadiusSmall,
      fontFamily: "'Cascadia Code', 'Consolas', monospace",
      fontSize: tokens.fontSizeBase200,
      color: tokens.colorNeutralForeground2,
      borderLeft: 'none',
      display: 'block',
    },
    '& ul': {
      paddingLeft: '20px',
      marginTop: '4px',
      marginBottom: '4px',
    },
    '& ol': {
      paddingLeft: '20px',
      marginTop: '4px',
      marginBottom: '4px',
    },
  },
  transcriptBoxHtml: {
    padding: tokens.spacingHorizontalM,
    backgroundColor: tokens.colorNeutralBackground3,
    borderRadius: tokens.borderRadiusSmall,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground1,
    maxHeight: '400px',
    overflow: 'auto',
    wordBreak: 'break-word' as const,
    lineHeight: '1.5',
    '& .transcript-row': {
      marginTop: '2px',
      marginBottom: '2px',
      padding: '4px 8px',
    },
    '& .transcript-speaker': {
      fontWeight: tokens.fontWeightSemibold as unknown as number,
      color: tokens.colorNeutralForeground1,
    },
    '& .transcript-time': {
      color: tokens.colorNeutralForeground3,
      fontSize: tokens.fontSizeBase100,
      marginRight: '8px',
    },
    '& .transcript-text': {
      color: tokens.colorNeutralForeground1,
    },
  },
  transcriptBoxPlain: {
    padding: tokens.spacingHorizontalM,
    backgroundColor: tokens.colorNeutralBackground3,
    borderRadius: tokens.borderRadiusSmall,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground1,
    maxHeight: '400px',
    overflow: 'auto',
    whiteSpace: 'pre-wrap' as const,
    wordBreak: 'break-word' as const,
    fontFamily: 'monospace',
  },
});
